import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/user/create/many/user.create.many.mutation.gql"
import type {
  UserCreateManyMutation,
  UserCreateManyMutationVariables,
} from "@/v2-backoffice-client/user/create/many/__types__/user.create.many.mutation"

type Options = MutationHookOptions<
  UserCreateManyMutation,
  UserCreateManyMutationVariables
>

export function useUserCreateManyMutation(options?: Options) {
  return useMutation<UserCreateManyMutation, UserCreateManyMutationVariables>(
    mutation,
    options,
  )
}
